/**
 * Manually add an Activity Block (day/time/category) to the weekly grid.
 */
import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { toast } from 'sonner';
import api from '../../lib/api';
import { CATEGORY_META } from './plannerConstants';

export function AddBlockModal({ open, onClose, weekStart, onCreated }) {
  const [category, setCategory] = useState('prospecting');
  const [day, setDay] = useState('0');
  const [startTime, setStartTime] = useState('09:00');
  const [endTime, setEndTime] = useState('11:00');
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    setSaving(true);
    try {
      const base = new Date(weekStart);
      base.setDate(base.getDate() + Number(day));
      const [sh, sm] = startTime.split(':').map(Number);
      const [eh, em] = endTime.split(':').map(Number);
      const start = new Date(base); start.setHours(sh, sm, 0, 0);
      const end = new Date(base); end.setHours(eh, em, 0, 0);
      if (end <= start) { toast.error('End time must be after start time'); setSaving(false); return; }
      await api.createPlannerBlock({ activity_category: category, start: start.toISOString(), end: end.toISOString() });
      toast.success('Activity block added');
      onCreated();
      onClose();
    } catch (e) {
      toast.error(e.message || 'Failed to add block');
    } finally {
      setSaving(false);
    }
  };

  const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent data-testid="add-block-modal">
        <DialogHeader>
          <DialogTitle>Add Activity Block</DialogTitle>
          <DialogDescription>Choose a category, day, and time to add a work block to your week.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <Select value={category} onValueChange={setCategory}>
            <SelectTrigger data-testid="add-block-category-select"><SelectValue /></SelectTrigger>
            <SelectContent>
              {Object.entries(CATEGORY_META).map(([k, v]) => <SelectItem key={k} value={k}>{v.label}</SelectItem>)}
            </SelectContent>
          </Select>
          <Select value={day} onValueChange={setDay}>
            <SelectTrigger data-testid="add-block-day-select"><SelectValue /></SelectTrigger>
            <SelectContent>
              {days.map((d, i) => <SelectItem key={i} value={String(i)}>{d}</SelectItem>)}
            </SelectContent>
          </Select>
          <div className="grid grid-cols-2 gap-3">
            <Input type="time" value={startTime} onChange={(e) => setStartTime(e.target.value)} data-testid="add-block-start-input" />
            <Input type="time" value={endTime} onChange={(e) => setEndTime(e.target.value)} data-testid="add-block-end-input" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="add-block-cancel-btn">Cancel</Button>
          <Button onClick={submit} disabled={saving} data-testid="add-block-submit-btn">{saving ? 'Adding…' : 'Add Block'}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
